
   window.ChatWidgetConfig = {
      webhook: {
         url: 'https://n8n.ampowerad.com/webhook/1538379b-8391-4655-8058-b7a407d1155d/chat',
         route: 'general'
      },
      branding: {
         logo: 'https://cdn.shopify.com/s/files/1/0272/0943/3149/files/quokka_assist.jpg?v=1774991220',
         name: 'Quokka Assistant', // Your company name
         welcomeText: 'Greetings 👋<br>Don\'t waste your time searching for information. Just write to me, and I\'ll help you as quickly as possible...', //Welcome message
         responseTimeText: 'We respond within seconds' //Response time message
      },
      style: {
         primaryColor: '#803cee', //Primary color
         secondaryColor: '#6b3fd4', //Secondary color
         position: 'right', //Position of the widget (left or right)
         backgroundColor: '#fff', //Background color of the chat widget
         fontColor: '#854fff' //Text color for messages and interface
      },
      poweredBy: {
         show: false,                                   // show or hide
         text: "Powered by ChatBot",
         link: "https://quokka.com"
      },
      showWelcomeScreen: false,                       // hide or show the welcome screen
      sendButtonText: "Enter",                         // send button text
      inputPlaceholder: 'Your message...',             // input field placeholder text
      typingText: 'Quokka is typing...',                // text displayed when typing
      autoInit: {
         enabled: false,                               // auto-open (proactive invitation disabled)
         delay: 3,                                     // after 3 seconds
         hideAfterClose: 10                            // show welcome screen again after 10 minutes
      },
      mobile: {
         enablePopupNotification: true,                // show popup notification on mobile
         popupDuration: 10000,                          // popup display duration (10 sec)
         fullScreenChat: true                          // full-screen chat on mobile
      },
      animation: {
         enablePulse: true,                            // enable pulsing button animation
         pulseDuration: 2                              // pulse duration in seconds
      },
      typing: {
         minDelay: 1000,                               // minimum delay before showing "Typing..." (1 sec)
         maxDelay: 3000,                               // maximum delay (3 sec)
         charDelay: 50                                 // additional delay per character (50 ms)
      }
   };